import { getListarComercios } from '@/services/Comercios/getListarComercios.js';
import { ConfigStore } from "../Config/config.store.js";
import { LoginStore } from "../login.store.js";

const ListarComercios = {
    namespaced: true,
    state: {
        listarComercios: [],
    },
    mutations: {
        setListarComercios(state, payload) {
            state.listarComercios = payload.data;
        },
    },
    actions: {
        getListaComercios: async function({ commit }, ) {
            // if (data == 'es') {
                const response = await getListarComercios(
                    `${process.env.VUE_APP_API_URL}${ConfigStore.state.endpoints.getListarComercios}`, // url
                    LoginStore.state.token,
                    );
                    if (response.status === 200) {
                        commit("setListarComercios", response.data); // aquí llegan bien los datos
                    }
                    return response;
        }
    },
    getters:{
        getListadoComercios(state){
             return state.listarComercios   
        }
    }
}

export { ListarComercios }